import { Box, Tab, Tabs, Typography, Stack } from "@mui/material";
import { useState } from "react";
import { TabContext } from "@mui/lab";
import { useLocation } from "react-router-dom";
import LevelCard from "./tiresiaComponents/levelCard";
import TiresiaAnalysis from "./analysis";
import Behaviors from "./behaviors";

const Tiresia = () => {
  const location = useLocation();
  const [tabValue, setTabValue] = useState(location.state?.tab ?? "1");
  return (
    <Box sx={{ m: "20px", display: "flex", flexDirection: "column", gap: 2 }}>

      {/* ── Header ── */}
      <Stack direction="row" alignItems="flex-end" justifyContent="space-between" flexWrap="wrap" gap={1}>
        <Box>
          <Typography variant="h2" fontWeight="bold" sx={{ mb: 0.5 }}>
            Tires-IA
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 580 }}>
            Highlights the most anomalous movements recorded by LECS using advanced AI
            algorithms, extracting and contextualizing behavioral anomalies in real time.
          </Typography>
        </Box>
      </Stack>

      <LevelCard />

      {/* ── Tabs ── */}
      <TabContext value={tabValue}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={(_, v) => setTabValue(v)}
            sx={{
              minHeight: 40,
              "& .MuiTabs-indicator": { backgroundColor: "#459095", height: 2 },
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: 14,
                minHeight: 40,
                minWidth: 110,
                color: "text.secondary",
                "&.Mui-selected": { color: "#459095" },
              },
            }}
          >
            <Tab label="Behaviors" value="1" />
            <Tab label="Analysis"  value="0" />
          </Tabs>
        </Box>

        {tabValue === "0" && (
          <Box sx={{ pt: 2 }}>
            <TiresiaAnalysis />
          </Box>
        )}
        {tabValue === "1" && (
          <Box sx={{ pt: 2 }}>
            <Behaviors />
          </Box>
        )}
      </TabContext>

    </Box>
  );
};

export default Tiresia;
